//
// Copyright 2021 DXOS.org
//
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_descriptor, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/config.proto.
 */
export const file_dxos_config = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_any, file_google_protobuf_struct, file_google_protobuf_descriptor]);
/**
 * Describes the message dxos.config.Config.
 * Use `create(ConfigSchema)` to create a new message.
 */
export const ConfigSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 0);
/**
 * Describes the message dxos.config.Package.
 * Use `create(PackageSchema)` to create a new message.
 */
export const PackageSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 1);
/**
 * Describes the message dxos.config.Repo.
 * Use `create(RepoSchema)` to create a new message.
 */
export const RepoSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 2);
/**
 * Describes the message dxos.config.Module.
 * Use `create(ModuleSchema)` to create a new message.
 */
export const ModuleSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 3);
/**
 * Describes the message dxos.config.Module.Build.
 * Use `create(Module_BuildSchema)` to create a new message.
 */
export const Module_BuildSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 3, 0);
/**
 * Describes the message dxos.config.Runtime.
 * Use `create(RuntimeSchema)` to create a new message.
 */
export const RuntimeSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4);
/**
 * Describes the message dxos.config.Runtime.Client.
 * Use `create(Runtime_ClientSchema)` to create a new message.
 */
export const Runtime_ClientSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 0);
/**
 * Describes the message dxos.config.Runtime.Client.Storage.
 * Use `create(Runtime_Client_StorageSchema)` to create a new message.
 */
export const Runtime_Client_StorageSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 0, 0);
/**
 * @generated from enum dxos.config.Runtime.Client.Storage.StorageDriver
 */
export var Runtime_Client_Storage_StorageDriver;
(function (Runtime_Client_Storage_StorageDriver) {
    /**
     * @generated from enum value: RAM = 0;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["RAM"] = 0] = "RAM";
    /**
     * @generated from enum value: IDB = 1;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["IDB"] = 1] = "IDB";
    /**
     * @generated from enum value: CHROME = 2;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["CHROME"] = 2] = "CHROME";
    /**
     * @generated from enum value: FIREFOX = 3;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["FIREFOX"] = 3] = "FIREFOX";
    /**
     * @generated from enum value: NODE = 4;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["NODE"] = 4] = "NODE";
    /**
     * @generated from enum value: WEBFS = 5;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["WEBFS"] = 5] = "WEBFS";
    /**
     * Key storage only.
     *
     * @generated from enum value: LEVELJS = 11;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["LEVELJS"] = 11] = "LEVELJS";
    /**
     * @generated from enum value: JSONDOWN = 12;
     */
    Runtime_Client_Storage_StorageDriver[Runtime_Client_Storage_StorageDriver["JSONDOWN"] = 12] = "JSONDOWN";
})(Runtime_Client_Storage_StorageDriver || (Runtime_Client_Storage_StorageDriver = {}));
/**
 * Describes the enum dxos.config.Runtime.Client.Storage.StorageDriver.
 */
export const Runtime_Client_Storage_StorageDriverSchema = /*@__PURE__*/ enumDesc(file_dxos_config, 4, 0, 0, 0);
/**
 * / Storage backing for SQLite (indexes & persistent state). The caller must supply the
 * / matching worker factory / path — `createClientServices` does not pick a mode from the
 * / presence of options.
 *
 * @generated from enum dxos.config.Runtime.Client.Storage.SqliteMode
 */
export var Runtime_Client_Storage_SqliteMode;
(function (Runtime_Client_Storage_SqliteMode) {
    /**
     * @generated from enum value: UNSPECIFIED_SQLITE_MODE = 0;
     */
    Runtime_Client_Storage_SqliteMode[Runtime_Client_Storage_SqliteMode["UNSPECIFIED_SQLITE_MODE"] = 0] = "UNSPECIFIED_SQLITE_MODE";
    /**
     * / Ephemeral in-memory SQLite. Indexes are rebuilt on each start.
     *
     * @generated from enum value: MEMORY = 1;
     */
    Runtime_Client_Storage_SqliteMode[Runtime_Client_Storage_SqliteMode["MEMORY"] = 1] = "MEMORY";
    /**
     * / OPFS-backed SQLite running in a dedicated worker (browser).
     * / Requires `createOpfsWorker` to be passed to `createClientServices`.
     *
     * @generated from enum value: OPFS = 2;
     */
    Runtime_Client_Storage_SqliteMode[Runtime_Client_Storage_SqliteMode["OPFS"] = 2] = "OPFS";
    /**
     * / File-backed SQLite (Node/Bun). Uses `data_root` to locate the database file.
     *
     * @generated from enum value: FILE = 3;
     */
    Runtime_Client_Storage_SqliteMode[Runtime_Client_Storage_SqliteMode["FILE"] = 3] = "FILE";
})(Runtime_Client_Storage_SqliteMode || (Runtime_Client_Storage_SqliteMode = {}));
/**
 * Describes the enum dxos.config.Runtime.Client.Storage.SqliteMode.
 */
export const Runtime_Client_Storage_SqliteModeSchema = /*@__PURE__*/ enumDesc(file_dxos_config, 4, 0, 0, 1);
/**
 * Describes the message dxos.config.Runtime.Client.Log.
 * Use `create(Runtime_Client_LogSchema)` to create a new message.
 */
export const Runtime_Client_LogSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 0, 1);
/**
 * Describes the message dxos.config.Runtime.Client.EdgeFeatures.
 * Use `create(Runtime_Client_EdgeFeaturesSchema)` to create a new message.
 */
export const Runtime_Client_EdgeFeaturesSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 0, 2);
/**
 * / Where client services run. Drives `createClientServices` routing.
 *
 * @generated from enum dxos.config.Runtime.Client.ServicesMode
 */
export var Runtime_Client_ServicesMode;
(function (Runtime_Client_ServicesMode) {
    /**
     * @generated from enum value: UNSPECIFIED_SERVICES_MODE = 0;
     */
    Runtime_Client_ServicesMode[Runtime_Client_ServicesMode["UNSPECIFIED_SERVICES_MODE"] = 0] = "UNSPECIFIED_SERVICES_MODE";
    /**
     * / Run services in the same thread as the client.
     *
     * @generated from enum value: HOST = 1;
     */
    Runtime_Client_ServicesMode[Runtime_Client_ServicesMode["HOST"] = 1] = "HOST";
    /**
     * / @deprecated Removed in favour of DEDICATED_WORKER. Value reserved for wire compatibility.
     *
     * @generated from enum value: SHARED_WORKER = 2;
     */
    Runtime_Client_ServicesMode[Runtime_Client_ServicesMode["SHARED_WORKER"] = 2] = "SHARED_WORKER";
    /**
     * / Run services in a dedicated Worker elected via a lock (leader/follower).
     *
     * @generated from enum value: DEDICATED_WORKER = 3;
     */
    Runtime_Client_ServicesMode[Runtime_Client_ServicesMode["DEDICATED_WORKER"] = 3] = "DEDICATED_WORKER";
})(Runtime_Client_ServicesMode || (Runtime_Client_ServicesMode = {}));
/**
 * Describes the enum dxos.config.Runtime.Client.ServicesMode.
 */
export const Runtime_Client_ServicesModeSchema = /*@__PURE__*/ enumDesc(file_dxos_config, 4, 0, 0);
/**
 * / Which path evaluates ECHO queries on the host.
 *
 * @generated from enum dxos.config.Runtime.Client.QueryExecutor
 */
export var Runtime_Client_QueryExecutor;
(function (Runtime_Client_QueryExecutor) {
    /**
     * @generated from enum value: UNSPECIFIED_QUERY_EXECUTOR = 0;
     */
    Runtime_Client_QueryExecutor[Runtime_Client_QueryExecutor["UNSPECIFIED_QUERY_EXECUTOR"] = 0] = "UNSPECIFIED_QUERY_EXECUTOR";
    /**
     * / Load the objects a plan touches and evaluate every step in JS.
     *
     * @generated from enum value: MEMORY = 1;
     */
    Runtime_Client_QueryExecutor[Runtime_Client_QueryExecutor["MEMORY"] = 1] = "MEMORY";
    /**
     * / Compile the plan into one SQLite statement over the index tables and load no documents.
     * / The default.
     *
     * @generated from enum value: SQL = 2;
     */
    Runtime_Client_QueryExecutor[Runtime_Client_QueryExecutor["SQL"] = 2] = "SQL";
})(Runtime_Client_QueryExecutor || (Runtime_Client_QueryExecutor = {}));
/**
 * Describes the enum dxos.config.Runtime.Client.QueryExecutor.
 */
export const Runtime_Client_QueryExecutorSchema = /*@__PURE__*/ enumDesc(file_dxos_config, 4, 0, 1);
/**
 * Describes the message dxos.config.Runtime.App.
 * Use `create(Runtime_AppSchema)` to create a new message.
 */
export const Runtime_AppSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 1);
/**
 * Describes the message dxos.config.Runtime.App.BuildInfo.
 * Use `create(Runtime_App_BuildInfoSchema)` to create a new message.
 */
export const Runtime_App_BuildInfoSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 1, 0);
/**
 * Describes the message dxos.config.Runtime.Agent.
 * Use `create(Runtime_AgentSchema)` to create a new message.
 */
export const Runtime_AgentSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 2);
/**
 * Describes the message dxos.config.Runtime.Agent.Plugin.
 * Use `create(Runtime_Agent_PluginSchema)` to create a new message.
 */
export const Runtime_Agent_PluginSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 2, 0);
/**
 * Describes the message dxos.config.Runtime.CLI.
 * Use `create(Runtime_CLISchema)` to create a new message.
 */
export const Runtime_CLISchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 3);
/**
 * Describes the message dxos.config.Runtime.CLI.AppServe.
 * Use `create(Runtime_CLI_AppServeSchema)` to create a new message.
 */
export const Runtime_CLI_AppServeSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 3, 0);
/**
 * Describes the message dxos.config.Runtime.CLI.AppServe.Serve.
 * Use `create(Runtime_CLI_AppServe_ServeSchema)` to create a new message.
 */
export const Runtime_CLI_AppServe_ServeSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 3, 0, 0);
/**
 * Describes the message dxos.config.Runtime.CLI.Package.
 * Use `create(Runtime_CLI_PackageSchema)` to create a new message.
 */
export const Runtime_CLI_PackageSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 3, 1);
/**
 * Describes the message dxos.config.Runtime.Props.
 * Use `create(Runtime_PropsSchema)` to create a new message.
 */
export const Runtime_PropsSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 4);
/**
 * Describes the message dxos.config.Runtime.System.
 * Use `create(Runtime_SystemSchema)` to create a new message.
 */
export const Runtime_SystemSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 5);
/**
 * Describes the message dxos.config.Runtime.Kube.
 * Use `create(Runtime_KubeSchema)` to create a new message.
 */
export const Runtime_KubeSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6);
/**
 * Describes the message dxos.config.Runtime.Kube.Autoupdate.
 * Use `create(Runtime_Kube_AutoupdateSchema)` to create a new message.
 */
export const Runtime_Kube_AutoupdateSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 0);
/**
 * Describes the message dxos.config.Runtime.Kube.Https.
 * Use `create(Runtime_Kube_HttpsSchema)` to create a new message.
 */
export const Runtime_Kube_HttpsSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 1);
/**
 * Describes the message dxos.config.Runtime.Kube.P2P.
 * Use `create(Runtime_Kube_P2PSchema)` to create a new message.
 */
export const Runtime_Kube_P2PSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 2);
/**
 * Describes the message dxos.config.Runtime.Kube.Monitoring.
 * Use `create(Runtime_Kube_MonitoringSchema)` to create a new message.
 */
export const Runtime_Kube_MonitoringSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 3);
/**
 * Describes the message dxos.config.Runtime.Kube.Trace.
 * Use `create(Runtime_Kube_TraceSchema)` to create a new message.
 */
export const Runtime_Kube_TraceSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 4);
/**
 * Describes the message dxos.config.Runtime.Kube.Telemetry.
 * Use `create(Runtime_Kube_TelemetrySchema)` to create a new message.
 */
export const Runtime_Kube_TelemetrySchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 5);
/**
 * Describes the message dxos.config.Runtime.Kube.Gravity.
 * Use `create(Runtime_Kube_GravitySchema)` to create a new message.
 */
export const Runtime_Kube_GravitySchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 6);
/**
 * Describes the message dxos.config.Runtime.Kube.AppTunneling.
 * Use `create(Runtime_Kube_AppTunnelingSchema)` to create a new message.
 */
export const Runtime_Kube_AppTunnelingSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 7);
/**
 * Describes the message dxos.config.Runtime.Kube.Bots.
 * Use `create(Runtime_Kube_BotsSchema)` to create a new message.
 */
export const Runtime_Kube_BotsSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 8);
/**
 * Describes the message dxos.config.Runtime.Kube.KuboApiAuthorization.
 * Use `create(Runtime_Kube_KuboApiAuthorizationSchema)` to create a new message.
 */
export const Runtime_Kube_KuboApiAuthorizationSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 6, 9);
/**
 * Describes the message dxos.config.Runtime.Services.
 * Use `create(Runtime_ServicesSchema)` to create a new message.
 */
export const Runtime_ServicesSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7);
/**
 * Describes the message dxos.config.Runtime.Services.Kube.
 * Use `create(Runtime_Services_KubeSchema)` to create a new message.
 */
export const Runtime_Services_KubeSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 0);
/**
 * Describes the message dxos.config.Runtime.Services.Kube.Endpoints.
 * Use `create(Runtime_Services_Kube_EndpointsSchema)` to create a new message.
 */
export const Runtime_Services_Kube_EndpointsSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 0, 0);
/**
 * Describes the message dxos.config.Runtime.Services.AppServer.
 * Use `create(Runtime_Services_AppServerSchema)` to create a new message.
 */
export const Runtime_Services_AppServerSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 1);
/**
 * Describes the message dxos.config.Runtime.Services.Dxns.
 * Use `create(Runtime_Services_DxnsSchema)` to create a new message.
 */
export const Runtime_Services_DxnsSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 2);
/**
 * Describes the message dxos.config.Runtime.Services.Ipfs.
 * Use `create(Runtime_Services_IpfsSchema)` to create a new message.
 */
export const Runtime_Services_IpfsSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 3);
/**
 * Describes the message dxos.config.Runtime.Services.Signal.
 * Use `create(Runtime_Services_SignalSchema)` to create a new message.
 */
export const Runtime_Services_SignalSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 4);
/**
 * Describes the message dxos.config.Runtime.Services.Ice.
 * Use `create(Runtime_Services_IceSchema)` to create a new message.
 */
export const Runtime_Services_IceSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 5);
/**
 * Describes the message dxos.config.Runtime.Services.IceProvider.
 * Use `create(Runtime_Services_IceProviderSchema)` to create a new message.
 */
export const Runtime_Services_IceProviderSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 6);
/**
 * Describes the message dxos.config.Runtime.Services.Machine.
 * Use `create(Runtime_Services_MachineSchema)` to create a new message.
 */
export const Runtime_Services_MachineSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 7);
/**
 * Describes the message dxos.config.Runtime.Services.BotHost.
 * Use `create(Runtime_Services_BotHostSchema)` to create a new message.
 */
export const Runtime_Services_BotHostSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 8);
/**
 * Describes the message dxos.config.Runtime.Services.Publisher.
 * Use `create(Runtime_Services_PublisherSchema)` to create a new message.
 */
export const Runtime_Services_PublisherSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 9);
/**
 * Describes the message dxos.config.Runtime.Services.Tunneling.
 * Use `create(Runtime_Services_TunnelingSchema)` to create a new message.
 */
export const Runtime_Services_TunnelingSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 10);
/**
 * Describes the message dxos.config.Runtime.Services.Supervisor.
 * Use `create(Runtime_Services_SupervisorSchema)` to create a new message.
 */
export const Runtime_Services_SupervisorSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 11);
/**
 * Describes the message dxos.config.Runtime.Services.Faasd.
 * Use `create(Runtime_Services_FaasdSchema)` to create a new message.
 */
export const Runtime_Services_FaasdSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 12);
/**
 * Describes the message dxos.config.Runtime.Services.AgentHosting.
 * Use `create(Runtime_Services_AgentHostingSchema)` to create a new message.
 */
export const Runtime_Services_AgentHostingSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 13);
/**
 * Describes the message dxos.config.Runtime.Services.Edge.
 * Use `create(Runtime_Services_EdgeSchema)` to create a new message.
 */
export const Runtime_Services_EdgeSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 14);
/**
 * Describes the message dxos.config.Runtime.Services.Ai.
 * Use `create(Runtime_Services_AiSchema)` to create a new message.
 */
export const Runtime_Services_AiSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 15);
/**
 * Describes the message dxos.config.Runtime.Services.Hub.
 * Use `create(Runtime_Services_HubSchema)` to create a new message.
 */
export const Runtime_Services_HubSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 16);
/**
 * Describes the message dxos.config.Runtime.Services.EdgeService.
 * Use `create(Runtime_Services_EdgeServiceSchema)` to create a new message.
 */
export const Runtime_Services_EdgeServiceSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 17);
/**
 * Describes the message dxos.config.Runtime.Services.Sandbox.
 * Use `create(Runtime_Services_SandboxSchema)` to create a new message.
 */
export const Runtime_Services_SandboxSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 7, 18);
/**
 * Describes the message dxos.config.Runtime.Keys.
 * Use `create(Runtime_KeysSchema)` to create a new message.
 */
export const Runtime_KeysSchema = /*@__PURE__*/ messageDesc(file_dxos_config, 4, 8);
/**
 * @generated from extension: optional string env_var = 1000;
 */
export const env_var = /*@__PURE__*/ extDesc(file_dxos_config, 0);
//# sourceMappingURL=config_pb.js.map